import { render } from "./Slideshow.vue?vue&type=template&id=bb3c0cc6"
import script from "./Slideshow.vue?vue&type=script&lang=js"
export * from "./Slideshow.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__